<template>
  <v-dialog
    ref="dialogDate"
    v-model="modalDate"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        prepend-inner-icon="mdi-calendar-clock"
        readonly
        solo
        v-on="on"
      />
    </template>
    <v-date-picker
      @change="handleChangeIsModified"
      v-model="date"
      :locale="locale"
      scrollable
      dark
      @input="handleChangeIsModified"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="modalDate = false"
      >
        {{ $t('common.cancel', locale) }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="handleSaveDate(date)"
      >
        {{ $t('common.ok', locale) }}
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    date: null,
    modalDate: false,
  }),
  watch: {
    value () {
      this.date = this.value
    },
  },
  mounted () {
    this.date = this.value
  },
  methods: {
    handleSaveDate (v) {
      this.$refs.dialogDate.save(v)
      this.handleChangeIsModified()
    },
    handleChangeIsModified () {
      this.onChange(this.date)
    },
  },
}
</script>

